module.exports = __webpack_public_path__ + "img/icone-doces.463d6de3.svg";